import { CrossDomainParams } from "./types";

/**
 * Append cross-domain parameters to a URL
 */
export const appendCrossDomainParams = (
  url: string,
  params: CrossDomainParams,
): string => {
  if (!params.clientId && !params.sessionId) {
    return url;
  }

  const urlObj = new URL(url);

  if (params.clientId) {
    urlObj.searchParams.set("clientId", params.clientId);
  }

  if (params.sessionId) {
    urlObj.searchParams.set("sessionId", params.sessionId);
  }

  return urlObj.toString();
};

/**
 * Get funnel URL with cross-domain tracking parameters
 * Uses cross-domain params from context
 */
export const getFunnelURLWithTracking = (
  baseURL: string,
  contextParams?: CrossDomainParams,
): string => {
  try {
    if (contextParams && (contextParams.clientId || contextParams.sessionId)) {
      return appendCrossDomainParams(baseURL, contextParams);
    }

    // No context params available, return base URL
    return baseURL;
  } catch (error) {
    console.error("Error getting cross-domain parameters:", error);
    return baseURL;
  }
};
